/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I count syllables for a poem or haiku?`)
};

const es_syl_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo contar sílabas para un poema o un haiku?`)
};

const de_syl_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich Silben für ein Gedicht oder Haiku zählen?`)
};

const nl_syl_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik lettergrepen tellen voor een gedicht of haiku?`)
};

const fr_syl_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je compter les syllabes d'un poème ou d'un haïku ?`)
};

const it_syl_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso contare le sillabe per una poesia o un haiku?`)
};

const pt_br2_syl_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso contar sílabas para um poema ou haiku?`)
};

const pt_syl_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso contar sílabas para um poema ou haiku?`)
};

const ja_syl_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詩や俳句の音節数もカウントできますか？`)
};

const zh_syl_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以统计诗歌或俳句的音节数吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_hub_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_hub_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_hub_faq2_q", locale)
	if (locale === "en") return en_syl_hub_faq2_q(inputs)
	if (locale === "es") return es_syl_hub_faq2_q(inputs)
	if (locale === "de") return de_syl_hub_faq2_q(inputs)
	if (locale === "nl") return nl_syl_hub_faq2_q(inputs)
	if (locale === "fr") return fr_syl_hub_faq2_q(inputs)
	if (locale === "it") return it_syl_hub_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_syl_hub_faq2_q(inputs)
	if (locale === "pt") return pt_syl_hub_faq2_q(inputs)
	if (locale === "ja") return ja_syl_hub_faq2_q(inputs)
	return zh_syl_hub_faq2_q(inputs)
};